var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCafesInfusiones = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.1463C20.469 16.1463 22 13.5907 22 12.2439C22 10.8971 20.8805 9.80487 19.5 9.80487C18.1195 9.80487 17 10.8971 17 12.2439",
    stroke: "#BF360C",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7856 7.35073L13.6266 7.12829C13.5681 7.0361 13.0516 6.20244 13.0516 5.40732C13.0516 4.92976 13.2396 4.63415 13.3766 4.41902C13.4856 4.24732 13.5516 4.14439 13.5516 3.9439C13.5516 3.50585 13.2451 2.92439 13.1261 2.73707L12.9846 2.51366L13.8326 2L13.9761 2.22244C14.0346 2.31463 14.5511 3.14829 14.5511 3.94341C14.5511 4.42146 14.3631 4.71707 14.2261 4.93268C14.1171 5.1039 14.0511 5.20732 14.0511 5.40683C14.0511 5.84488 14.3576 6.42634 14.4766 6.61366L14.6336 6.83707L13.7856 7.35073Z",
    fill: "#BCAAA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 7.35073L11.1339 7.12829C11.0754 7.0361 10.5589 6.20244 10.5589 5.40732C10.5589 4.92976 10.7469 4.63415 10.8839 4.41902C10.9929 4.24732 11.0589 4.14439 11.0589 3.9439C11.0589 3.50585 10.7524 2.92439 10.6334 2.73707L10.4919 2.51366L11.3399 2L11.4834 2.22244C11.5419 2.31463 12.0584 3.14829 12.0584 3.94341C12.0584 4.42146 11.8704 4.71707 11.7334 4.93268C11.6244 5.1039 11.5584 5.20732 11.5584 5.40683C11.5584 5.84488 11.8649 6.42634 11.9839 6.61366L12.1409 6.83707L11.2929 7.35073Z",
    fill: "#BCAAA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.801 7.35073L8.642 7.12829C8.5835 7.0361 8.067 6.20244 8.067 5.40732C8.067 4.92976 8.255 4.63415 8.392 4.41902C8.501 4.24732 8.567 4.14439 8.567 3.9439C8.567 3.50585 8.2605 2.92439 8.1415 2.73707L8 2.51366L8.848 2L8.9915 2.22244C9.05 2.31463 9.5665 3.14829 9.5665 3.94341C9.5665 4.42146 9.3785 4.71707 9.2415 4.93268C9.1325 5.1039 9.0665 5.20732 9.0665 5.40683C9.0665 5.84488 9.373 6.42634 9.492 6.61366L9.649 6.83707L8.801 7.35073Z",
    fill: "#BCAAA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.41461C3.5 12.12 7 19.561 7 19.561H15C15 19.561 18.5 12.12 18.5 5.41461H3.5Z",
    fill: "#FF3D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.0732V19.561C2 19.561 4.173 22 6 22H16C17.827 22 20 19.561 20 19.561V19.0732H2Z",
    fill: "#CFD8DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.626 18.0975H6.37402C6.53602 18.499 6.67602 18.8297 6.78202 19.0731H15.2185C15.324 18.8297 15.464 18.499 15.626 18.0975Z",
    fill: "#BF360C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCafesInfusiones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CafesInfusiones.2467415c.svg";
export { ForwardRef as ReactComponent };